import toast from './toast';

/**
 * Copy-on-click for `<a data-copy="...">` in server-rendered activity HTML.
 *
 * The members API renders a campaign's `{{u_link}}` placeholder as a link to
 * a copy page (for the mobile app, which can't run code inside activity
 * HTML). On web we copy the value in place instead of leaving the app. The
 * listener runs in the capture phase so a link inside a clickable tile
 * doesn't also open the tile.
 */
const onClick = (event) => {
  const anchor = event.target.closest && event.target.closest('a[data-copy]');
  if (!anchor) return;
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;

  event.preventDefault();
  event.stopPropagation();

  navigator.clipboard.writeText(anchor.dataset.copy)
    .then(() => {
      toast.show(toast.KIND.SUCCESS, 'Link copied.');
    })
    .catch(() => {
      // Clipboard blocked. Opening the copy page from here would be
      // popup-blocked (the click's activation is spent), so show the link.
      toast.show(
        toast.KIND.WARNING,
        `Could not copy to clipboard. Please copy your link manually: ${anchor.dataset.copy}`,
      );
    });
};

const install = () => {
  document.addEventListener('click', onClick, true);
};

const copyLinks = { install };

export default copyLinks;
